const permissions = {
  accounts: {
    'read:own': ['*'],
  },
  contacts: {
    'create:own': ['*'],
    'read:own': ['*'],
    'update:own': ['*'],
    'delete:own': ['*'],
  },
  companies: {
    'create:own': ['*'],
    'read:own': ['*'],
    'update:own': ['*'],
    'delete:own': ['*'],
  },
  contents: {
    'read:own': ['*'],
    'update:own': ['*'],
  },
  dashboards: {
    'read:own': ['*'],
  },
  feedbacks: {
    'create:own': ['*'],
  },
  discussions: {
    'create:own': ['*'],
    'read:own': ['*'],
    'update:own': ['*'],
    'delete:own': ['*'],
  },
  files: {
    'read:own': ['*'],
  },
  informations: {
    'read:own': ['*'],
  },
  invoices: {
    'read:own': ['*'],
  },
  activities: {
    'read:own': ['*'],
    'create:own': ['*'],
    'update:own': ['*'],
    'delete:own': ['*'],
  },
  automations: {
    'read:own': ['*'],
  },
  meetings: {
    'read:own': ['*'],
  },
  objectives: {
    'read:own': ['*'],
  },
  scopes: {
    'read:own': ['*'],
  },
  users: {
    'read:own': ['*'],
    'update:own': ['*'],
    'delete:own': ['*'],
  },
  timelines: {
    'read:own': ['*'],
    'update:own': ['*'],
  },
}

export default permissions
